import { React, useState, useEffect } from 'react';
import PageHeader from 'utility/PageHeader';
import PageBody from 'utility/PageBody';
import { Button, Form, Input, Row, Col, Table, DatePicker, Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { HttpHandler } from '../../shared/httpHandler';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

const ChatHistory = () => {
  const httpHandler = new HttpHandler();

  const [searchForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });
    updateData(pagination);
  };

  const updateData = (pagination = tableParams.pagination) => {
    const { client, sales, timeRange, isRead } = searchForm.getFieldsValue();
    const isoTimeRange = timeRange.map((date) => date.toISOString());
    const { current, pageSize } = pagination;
    setLoading(true);
    httpHandler
      .get(
        `/line-official-mgmt/chat/history?client=${client}&sales=${sales}&is_read=${isRead}&page=${current}&page_size=${pageSize}&range=${isoTimeRange}`
      )
      .then((response) => {
        if (response.success) {
          // 自動新增id
          const data = response.data.map((item, index) => ({
            id: index,
            ...item,
          }));
          setTableData(data);
          setTableParams({
            ...tableParams,
            pagination: {
              ...pagination,
              total: response.total,
            },
          });
        } else {
          window.antdNotify('錯誤', response.data.message, 'fail');
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onFinish = async () => {
    setTableParams({
      ...tableParams,
      pagination: {
        current: 1,
        pageSize: 10,
      },
    });
    updateData({
      current: 1,
      pageSize: 10,
    });
  };

  const SearchBar = () => {
    return (
      <>
        <Form form={searchForm} name="searchForm" onFinish={onFinish}>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item label="客戶姓名" name="client">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="業代姓名" name="sales">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="日期區間"
                name="timeRange"
                rules={[{ required: true, message: '請選取時間範圍' }]}>
                {/* 結束日期只能選取當前日期之前 */}
                <DatePicker.RangePicker
                  disabledDate={(current) =>
                    current && current.isAfter(dayjs())
                  }
                />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item label="已讀狀態" name="isRead" initialValue="99">
                <Select>
                  <Select.Option value="99">全部</Select.Option>
                  <Select.Option value="1">已讀</Select.Option>
                  <Select.Option value="0">未讀</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={16} className="button-group">
              <Button
                type="primary"
                icon={<SearchOutlined />}
                htmlType="submit"
                className="button button--search">
                搜尋
              </Button>
            </Col>
          </Row>
        </Form>
      </>
    );
  };

  useEffect(() => {
    // 預設表單值
    searchForm.setFieldsValue({
      client: '',
      sales: '',
      timeRange: [dayjs().subtract(3, 'month'), dayjs()],
    });
    // 進入畫面時執行一次搜尋
    onFinish();
  }, []);

  const DataTable = (props) => {
    let columns = [
      {
        title: 'id',
        dataIndex: '_id',
        hidden: true,
      },
      // {
      //   title: '傳送人員',
      //   dataIndex: 'sender',
      // },
      {
        title: '業代',
        dataIndex: 'sales',
      },
      {
        title: '客戶',
        dataIndex: 'client',
      },
      {
        title: '訊息',
        dataIndex: 'message',
        render: (text, record) => {
          return (
            <span>
              [{record.sender}] {record.message}
            </span>
          );
        },
      },
      {
        title: '傳送日期',
        dataIndex: 'send_date',
      },
      {
        title: '傳送時間',
        dataIndex: 'send_time',
      },
      {
        title: '已讀狀態',
        dataIndex: '',
        render: (text, record) => {
          return <span>{record.is_read ? '已讀' : '未讀'}</span>;
        },
      },
    ].filter((item) => !item.hidden);

    return (
      <>
        <Table
          columns={columns}
          rowKey={(row) => row.id}
          dataSource={props.tableData}
          pagination={tableParams.pagination}
          loading={loading}
          bordered="true"
          scroll={{ x: 'max-content' }}
          onChange={handleTableChange}
        />
      </>
    );
  };

  DataTable.propTypes = {
    tableData: PropTypes.array,
  };

  const section = [
    {
      hasTitle: false,
      title: 'Search',
      children: <SearchBar />,
    },
    {
      hasTitle: false,
      title: 'Data',
      children: <DataTable tableData={tableData} />,
    },
  ];

  return (
    <div>
      <PageHeader functionName={'chat_history'}></PageHeader>
      <PageBody section={section}></PageBody>
    </div>
  );
};

export default ChatHistory;
